<template>
  <component :is="implName" />
</template>
<script>
/**
 * @module CourseSelectList 选课列表壳：由 `$courseSelect.campusVariant` 决定 BJ / Other 实现
 */
export default {
  name: 'CourseSelectList',
  inject: ['$courseSelect'],
  components: {
    ImplBJ: () => import('./BJ'),
    ImplOther: () => import('./Other')
  },
  computed: {
    implName() {
      return this.$courseSelect.campusVariant === 'bj' ? 'ImplBJ' : 'ImplOther';
    }
  }
};
</script>
